const AppSettings = {
    API_BASE_URL: "https://api.adblastx.com/api",
    // API_BASE_URL: "http://localhost:5215/api",
    Maintainance_Mode: false
};

export default AppSettings;
